import styled from 'styled-components'

import promoImage from '../../../assets/SelectSubscriptionScreen/promocja.svg'

export const SelectSubBox = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  position: relative;

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    height: unset;
  }
`

export const TwineBallAnnotation = styled.div`
  width: 12vw;
  height: 12vw;
  padding: 2% 5%;
  box-sizing: border-box;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 3;
  cursor: pointer;

  @media only screen and (max-width: 600px) {
    width: 100%;
    height: unset;
    border-radius: 19px;
    z-index: 6;
  }
`

export const SubPlanScreenCard = styled.div`
  margin: 2% 0 0 0;
  width: 60%;
  padding: 3%;
  box-sizing: border-box;
  border-radius: 30px;
  background-image: linear-gradient(
    to right,
    rgba(114, 143, 251, 0.8),
    rgba(232, 150, 177, 0.8) 98%
  );
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 6;

  &:hover {
    transform: scale(1.06);
  }

  &.promo {
    padding: 3% 5% 3% 3%;
  }

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

export const PackageButton = styled.button`
  background: #a1ff68;
  border: none !important;
  outline: none;
  padding: 5px 20px;
  box-sizing: border-box;
  font-family: 'Nunito';
  font-size: 1.2rem !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.36px;
  text-align: left;
  color: #342152;
  border-radius: 7px;
`

export const DemoModeBox = styled.div`
  background: rgba(255, 255, 255, 0.3);
  border-radius: 30px;
  padding: 0.9rem;
  font-family: 'Nunito';
  font-size: 1.1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: -0.36px;
  text-align: center;
  color: #fff;
  margin-top: 3%;
  width: 60%;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 12;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }

  b {
    color: #a1ff68;
  }
`

export const SUB_container = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;

  @media only screen and (max-width: 2100px) {
    width: 80%;
  }
  @media only screen and (max-width: 1400px) {
    width: 90%;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

export const SUB_tile = styled.div`
  width: 49%;
  display: flex;
  flex-direction: column;
  background: rgb(114, 143, 252);
  background: linear-gradient(
    180deg,
    rgba(114, 143, 252, 1) 0%,
    rgba(234, 150, 176, 1) 100%
  );
  border-radius: 2rem;
  padding: 2rem;
  box-sizing: border-box;

  @media only screen and (max-width: 900px) {
    width: 90%;
    margin-top: calc(5% - 3px);
    border-radius: 0rem;

    &:first-child {
      /* border-top-left-radius: 2rem; */
      border-bottom-left-radius: 2rem;
    }

    &:last-child {
      border-top-right-radius: 2rem;
      border-bottom-right-radius: 2rem;
      margin-right: 5%;
    }
  }
`
export const SUB_ball = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${(props) => (props.color ? props.color : '#fff')};
`

export const PromoInfo = styled.div`
  position: absolute;
  background: url(${promoImage}) no-repeat center;
  background-size: contain;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;

  @media only screen and (max-width: 2100px) {
  }
  @media only screen and (max-width: 2000px) {
    transform: scale(0.9);
    left: -20px;
  }
  @media only screen and (max-width: 1400px) {
    transform: scale(0.8);
    left: -35px;
  }
  @media only screen and (max-width: 600px) {
    transform: scale(1);
    left: 10px;
  }
`
